var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeatmap = function SvgHeatmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#heatmap_svg__a)",
    rx: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heatmap_svg__a",
    x1: 14.857,
    x2: 3.429,
    y1: -1.143,
    y2: 18.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B20DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#20D3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#E9B93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#D55151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#912929"
  })))));
};
export default SvgHeatmap;